<script setup lang="ts">
import { ref } from 'vue'

defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{
  password?: string
}>(), {
  password: ''
})

const emit = defineEmits<{
  (e: 'passwordUpdate', value: string): void,
  (e: 'focusout'): void
}>()

const rootDiv = ref<HTMLDivElement | null>(null)
const type = ref<'password' | 'text'>('password')

const togglePasswordVisibility = () => {
  type.value = type.value === 'password' ? 'text' : 'password'
  rootDiv.value?.querySelector('.icon.icon-eye')?.classList.toggle('icon-eye-slash')
}

const handleInput = (event: Event) => {
  const value = (event.target as HTMLInputElement).value
  emit('passwordUpdate', value)
}
</script>

<template>
  <div ref="rootDiv"
       class="bx-form__password-wrapper">
    <input v-bind="$attrs"
           :type="type"
           :value="password"
           @input="handleInput"
           @focusout="emit('focusout')">
    <span class="icon icon-eye"
          @click="togglePasswordVisibility">
      <svg class="svg-eye">
        <use href="#eye" />
      </svg>
      <svg class="svg-eye-slash">
        <use href="#eye_slash" />
      </svg>
    </span>
  </div>
</template>
